<template>
    <div class="l content_right flex_container p10">
        <div class="left-section">
            <div class="title cl">
                <span class="l">套餐列表</span>
                <el-button class="r" type="primary" @click="addPackage">新增</el-button>
            </div>
            <ul>
                <li v-for="item in packageList" class="cl">
                    <span class="l name" :class="{active: item.servicepackageid === curPackage.servicepackageid}" @click="switchPackage(item)">{{item.servicepackagename}}</span>
                    <span class="r edit" title="编辑" @click="editPackage(item)"></span>
                    <span class="r delete" title="删除" @click="deletePackage(item.servicepackageid)"></span>
                </li>
            </ul>
        </div>
        <div class="center-section">
            <div class="title cl">
                <span class="l">资源组</span>
                <el-button class="r" type="primary" @click="editGroup">编辑资源组</el-button>
            </div>
            <ul>
                <li v-for="item in groupList" class="cl">
                    <span class="l name" :class="{active: item.resourcegroupid === curGroup.resourcegroupid}" @click="switchGroup(item)">{{item.resourcegroupname}}</span>
                </li>
            </ul>
        </div>
        <div class="right-section">
            <div class="title cl min-w-500">
                <label class="l">资源类型:</label>
                <span class="l type-item" :class="{active:resourceType == '0'}" @click="switchResourceType(0)">服务资源</span>
                <span class="l type-item" :class="{active:resourceType == '1'}" @click="switchResourceType(1)">客户端使用资源</span>
                <span class="l type-item" :class="{active:resourceType == '2'}" @click="switchResourceType(2)">服务端使用资源</span>
                <span class="l type-item" :class="{active:resourceType == '3'}" @click="switchResourceType('3')">不限</span>
                <el-button class="r" type="primary" @click="editResource">编辑资源</el-button>
            </div>
            <div class="table_container">
                <el-table :data="resourceList" :height="tableHeight">
                    <el-table-column label="资源名称" prop="resourcename"></el-table-column>
                    <el-table-column prop="conf" label="配置值"></el-table-column>
                    <el-table-column label="操作">
                        <template scope="scope">
                            <a @click="handleConfigEdit(scope.row)">编辑配置值</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog :title="diaTitle.package" v-model="dia.package" size="tiny">
            <package-edit v-if="dia.package" @cancel="cancel(0)" @refresh="refreshPackage" :config="configPackage"></package-edit>
        </el-dialog>
        <el-dialog title="编辑配置值" v-model="dia.conf" size="tiny">
            <config-edit v-if="dia.conf" @cancel="cancel(1)" @refresh="refreshResource" :config="configConf" :curPackage="curPackage" :curResources="resourceList" :curGroup="curGroup" :resourceType="resourceType"></config-edit>
        </el-dialog>
        <el-dialog title="编辑资源组" class="dia_config_edit_container" v-model="dia.group">
            <config-group v-if="dia.group" @cancel="cancel(2)" @refresh="refreshResource" :config="groupList" :completeResourceList="completeResourceList" :curPackage="curPackage"></config-group>
        </el-dialog>
        <el-dialog title="编辑资源" class="dia_config_edit_container" v-model="dia.resource">
            <config-resource v-if="dia.resource" @cancel="cancel(3)" @refresh="refreshResource" :config="configResourceList" :curPackage="curPackage" :curGroup="curGroup" :resourceType="resourceType"></config-resource>
        </el-dialog>
    </div>
</template>
<script>
    import {errorMessage} from '../../util'
    import {API_ROOT} from '../../config/index'
    import packageEdit from './packageEdit'
    import configEdit from './configEdit'
    import configResource from './configResource'
    import configGroup from './configGroup'
    export default {
        data: function(){
            return {
                packageList: [],
                resourceList: [],
                groupList: [],
                curPackage: {
                    servicepackageid: '',
                    memo: '',
                    servicepackagename: ''
                },
                curGroup: {
                    resourcegroupid: '',
                    resourcegroupname: ''
                },
                configPackage: {},
                configConf: {},
                configResourceList: [],
                dia: {
                    package: false,
                    conf: false,
                    resource: false,
                    group: false
                },
                diaTitle: {
                    package: '编辑套餐'
                },
                tableHeight: '',
                resourceClassified: {},
                completeResourceList: [],
                resourceType: '3'
            }
        },
        components: {
            packageEdit,
            configEdit,
            configResource,
            configGroup
        },
        created: function(){
            this.loadPackageListData(data => {
                 this.updateCurPackage(data[0])
                 this.loadResourceListData(data[0].servicepackageid)
            })
        },
        mounted: function(){
            let contentRight = document.getElementsByClassName('content_right')
            this.tableHeight =  contentRight[0].clientHeight  - 89
        },
        methods: {
            addPackage(){
                this.configPackage = {}
                this.diaTitle.package = '新增套餐'
                this.dia.package = true
            },
            editPackage(item){
                this.configPackage = item
                this.diaTitle = '新增套餐'
                this.dia.package = true
            },
            deletePackage(code){
                this.$confirm('确定删除？', '提示').then(() => {
                    this.$http.post(`/resourceconfig/servicepackage/delete`,{
                        servicepackageid: code
                    }).then(function(res){
                        this.$message('删除成功！')
                        this.loadPackageListData(data => {
                            if(code === this.curPackage.servicepackageid){
                                this.updateCurPackage(this.data[0])
                                this.loadResourceListData(data[0].servicepackageid)
                            }
                        })
                        this.refreshPackage()
                    }).catch(error => {
                        errorMessage(error, this)
                    })
                }).catch(() => {})
            },
            switchGroup(item){
                if (item) {
                    this.updateCurGroup(item)
                }
                this.resourceList = this.getResourceListByGroupId(this.curGroup.resourcegroupid)
            },
            switchPackage(item){
                this.resourceType = '3'
                this.updateCurGroup({})
                this.updateCurPackage(item)
                this.loadResourceListData(item.servicepackageid)
            },
            switchResourceType(type){
                this.resourceType = type + ''
                this.switchGroup()
            },
            // 更新当前资源组信息
            updateCurPackage(data = {}){
                for(let i in this.curPackage) {
                    this.curPackage[i] = data[i] ? data[i] : ''
                }
            },
            updateCurGroup(data = {}){
                for(let i in this.curGroup) {
                    this.curGroup[i] = data[i] ? data[i] : ''
                }
            },
            refreshPackage(){
                this.loadPackageListData()
                this.loadResourceListData(this.curPackage.servicepackageid)
            },
            editResource(){
                this.configResourceList = this.resourceList ? this.resourceList : []
                this.dia.resource = true
            },
            editGroup(){
                this.dia.group = true
            },
            handleConfigEdit(row){
                this.configConf = row
                this.dia.conf = true
            },
            refreshResource(){
                this.loadResourceListData(this.curPackage.servicepackageid)
            },
            // 加载列表数据
            loadPackageListData(callback) {
                this.$http.post(`/resourceconfig/servicepackage/list`,{}).then(function(res){
                    let respData = res.data.resp_data
                    this.packageList = respData
                    if (typeof callback === 'function') callback(respData)
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            // 加载指定套餐（code）的资源列表
            loadResourceListData(code) {
                this.$http.post(`/resourceconfig/servicepackage/detail`,{
                    servicepackageid: code
                }).then(function(res){
                    let respData = res.data.resp_data
                    let resourceDetail = this.parseDetail(respData)
                    this.groupList = resourceDetail.groupList
                    this.completeResourceList = respData
                    this.resourceClassified = resourceDetail.classsifyById
                    if(!this.curGroup.resourcegroupid) this.updateCurGroup(resourceDetail.groupList[0])
                    if (resourceDetail.groupList[0]) {
                        this.switchGroup()
                    } else {
                        this.resourceList = []
                    }
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            /*
            * @desc 通过特定套餐的资源项接口返回的数据解析出该套餐的资源组及各资源组下的资源项
            * @param {Array} data '/detail'接口返回数据
            * @return {Object} 返回对象包含两个属性，ret.groupList--套餐内包含的资源组列表，ret.classsifyById--以对象形式将资源项已资源组ID分类
            */
            parseDetail(data = []){
                let ret = {
                    groupList: [],
                    classsifyById: {}
                }
                data.forEach(item => {
                    let id = item.resourcegroupid
                    if (!ret.classsifyById[id]) {
                        let temp = {
                            resourcegroupid: item.resourcegroupid,
                            resourcegroupname: item.resourcegroupname
                        }
                        ret.classsifyById[id] = [item]
                        ret.groupList.push(temp)
                    } else {
                        ret.classsifyById[id].push(item)
                    }
                })
                return ret
            },
            // 根据给定的资源组ID获取当前类型的给定资源组下的资源列表
            getResourceListByGroupId(id){
                let ret = []
                let resourceList = this.resourceClassified[id]
                let type = this.resourceType
                if(type === '3'){
                    ret = resourceList
                } else {
                    resourceList.forEach(item => {
                        if (item.resourcetype === type) ret.push(item)
                    })
                }
                return ret
            },
            cancel(key){
                switch(key) {
                    case 0 : 
                        this.dia.package = false
                        break
                    case 1 : 
                        this.dia.conf = false
                        break
                    case 2 : 
                        this.dia.group = false
                        break
                    case 3 : 
                        this.dia.resource = false
                        break
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Index.vue?3f4663c5